import { Button, Dialog, TextField, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import CloseIcon from "@mui/icons-material/Close";
import Cookies from "js-cookie";
import React, { useRef, useState, useEffect, useContext } from "react";

import {
  privacyLink,
  termsLink,
} from "./app/components/ui library/helpers/consts";
import { userDBService } from "./app/components/ui library/helpers/dbInstances";
import { NetworkBackground } from "./app/components/NetworkBackground";
import AuthContext from "./app/context/AuthProvider";
import axios from "./app/components/api/axios";
import DataContext from "./app/context/DataContext";
import FormSubmitButton from "./app/components/global/FormComponents/FormSubmitButton";
import Modal from "./app/components/global/Modal";
import ModalButton from "./app/components/global/ModalButton";
import PasswordCreate from "./app/components/cm/Dashboard/FullPages/PasswordCreate";
import ResponseModal from "./app/components/global/ResponseModal";
import {inject} from "./lib/itn-ui-kit/services/service-container";

const Login = () => {
  const currentUserService = inject('current-user-service');
  const { setAuth } = useContext(AuthContext);
  const {
    accessToken,
    getCaseManagerName,
    setUserRoles,
    setCaseManagerPk,
    setUserType,
    getAccessToken,
    errorMessage,
    setErrorMessage,
    setLoggedInUser,
  } = useContext(DataContext);
  const userRef = useRef();

  const [username, setusername] = useState("");
  const [password, setpassword] = useState("");
  const [needsReset, setNeedsReset] = useState(false);
  const [loginAttempts, setLoginAttempts] = useState(0);
  const [showPasswordReset, setShowPasswordReset] = useState(false);
  const [passResetForgot, setPassResetForgot] = useState(false);
  const [resetEmailDialog, setResetEmailDialog] = useState(false);
  const [userResponse, setUserResponse] = useState("");
  const [email, setEmail] = useState("");
  const [token, setToken] = useState("");
  const [isError, setIsError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [openErrorModal, setOpenErrorModal] = useState(false);
  const navigate = useNavigate();
  const search = window.location.search;
  const url_params = new URLSearchParams(search);
  const auth_token_params = url_params.get("auth_token") ?? url_params.get("auth_token");
  const [readyToNavigate, setReadyToNavigate] = useState(false);

  useEffect(() => {
    if (errorMessage) {
      setOpenErrorModal(true);
    }
  }, [errorMessage]);

  useEffect(() => {
    userRef.current.focus();
  }, []);

  useEffect(() => {
    if(readyToNavigate){
      navigate("/landing");
    }else{
      if(accessToken){
        handleSubmit(null, accessToken);
      }else{
        navigate("/");
      }
    }
  }, [navigate, accessToken, readyToNavigate]);

  const countLoginAttempts = () => {
    setLoginAttempts(loginAttempts + 1);
    if (loginAttempts > -1) {
      setShowPasswordReset(true);
    }
  };

  const resetPasswordTrigger = () => {
    const userInfo = { email: email };

    axios
      .post(`/api/password_reset/`, userInfo, {
        "Content-Type": "application/json",
      })
      .then(() => {
        setEmail("");
        setShowPasswordReset(false);
        setResetEmailDialog(true);
        setPassResetForgot(false);
      })
      .catch((error) => {
        let res = error.response.data;
        let errArr = [];
        for (const item in res) {
          errArr.push(item + `: ${res[item]}`);
        }
        setErrorMessage(errArr);
      });
  };

useEffect(() => {
  if(auth_token_params){
    handleSubmit(null, auth_token_params);
  }
   
  }, [auth_token_params]);

  const setCookies = (userResp, token) => {
    Cookies.set("pnAccessToken", JSON.stringify(token));
    Cookies.set("pnCmPk", userResp.pk);
    Cookies.set(
      "userType",
      !userResp.entity ? "unknown" : userResp.entity.entity_type_label
    );
    userDBService.save("roles", userResp.groups);
    userDBService.save("permissions", userResp.permissions);
    userDBService.save("routes", userResp.routes);
    getAccessToken(token);
    getCaseManagerName(userResp.name);
    setCaseManagerPk(userResp.pk);
    setAuth({ username, password });
    setUserRoles({
      groups: userResp.groups,
      permissions: userResp.permissions,
    });
    setUserType(
      !userResp.entity ? "unknown" : userResp.entity.entity_type_label
    );
  };

  const handleSubmit = async (e, adminPanelAuthToken = null) => {
    setLoading(true);
    let response = null;
    try {
      if (adminPanelAuthToken) {
        response = await axios.get("/api/users/me", {
          headers: {
            Authorization: `Token ${adminPanelAuthToken}`,
          },
        });
      } else {
        console.log('manual submit')
        e.preventDefault();
        response = await axios.post(
          `/auth/login`,
          { username, password },
          { headers: { "Content-Type": "application/json" } }
        );
      }
      const { data, config } = response;
      let userData = data.user ? data.user : data;
      let currentToken = adminPanelAuthToken ? adminPanelAuthToken : data.token;
      Cookies.set("token_exp", data.expiry);
      await userDBService.save("baseURL", config.baseURL);
      await userDBService.save("userDetail", userData);
      currentUserService.user = userData;
      currentUserService.userRoles = {groups:data.groups, permissions:data.permissions};
      setNeedsReset(userData.requires_password_change);
      setLoggedInUser(userData); //setting data context 
      setUserResponse(userData);
      setToken(currentToken);
      if (userData.requires_password_change) {
        return;
      }
      setCookies(userData, currentToken);
      setLoading(false);
      setReadyToNavigate(true);
    } catch (err) {
      console.log(err)
      setLoading(false);
      setReadyToNavigate(false);
      if (err.response) {
        countLoginAttempts();
        if (!err.response) {
          //*Add custom message when there’s more than 1 token (display error message - possibly just stop custom setting these messages and use what the server sends)
          setErrorMessage("No Server Response");
        } else if (err.response.status === 400) {
          setErrorMessage("Unable to log in with provided credentials");
        } else if (err.response.status === 401) {
          setErrorMessage("Unauthorized");
        } else if (
          err.response.status === 403 &&
          !err.response.data.non_field_errors
        ) {
          setErrorMessage("Error Logging In");
        } else {
          setErrorMessage("Login Failed");
        }
      }
    }
  };

  const submitFormKeyPress = async (event) => {
    if (event.key === "Enter") {
      await handleSubmit(event);
    }
  };

  return (
    <div className="">
      <NetworkBackground />
      {/*<div className="">*/}
      {/*<h1 className="text-5xl font-bold text-gray-300 outline-2 outline-black">*/}
      {/*  <img*/}
      {/*    src="/assets/NetProApp_white_nobg.png"*/}
      {/*    alt=""*/}
      {/*    className="block w-1/2 mx-auto my-2"*/}
      {/*  />*/}
      {/*</h1>*/}
      {/*</div>*/}
      {needsReset ? (
        <PasswordCreate
          userResponse={userResponse}
          setCookies={setCookies}
          token={token}
        />
      ) : (
        <>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100vh",
            }}
          >
            <div
              style={{
                display: "flex",
                width: "fit-content",
                backgroundColor: "#ffffff",
                borderRadius: 10,
                borderLeft: "10px solid #257df8",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  paddingLeft: "35px",
                  paddingRight: "50px",
                }}
              >
                <img
                  alt=""
                  src="/assets/his-logo.svg"
                  className={`cursor-pointer duration-500 w-[150px] block mt-10`}
                />
                <Typography
                  style={{
                    fontFamily: "Roboto",
                    fontSize: "32px",
                    fontWeight: "300",
                    lineHeight: 1,
                    marginTop: "50px",
                  }}
                >
                  Welcome Back
                </Typography>
                <Typography
                  style={{
                    fontFamily: "Roboto",
                    fontSize: "48px",
                    fontWeight: "300",
                    lineHeight: 1,
                  }}
                >
                  Please Sign In
                </Typography>
                <Typography
                  style={{
                    fontFamily: "Roboto",
                    fontSize: "14px",
                    fontWeight: "300",
                    lineHeight: 1,
                    marginTop: "14px",
                    color: "#64748b",
                  }}
                >
                  Please enter your username and password
                </Typography>
                <form
                  className="grid grid-rows-3 l:mb-56"
                  style={{ marginTop: "14px" }}
                >
                  {" "}
                  <TextField
                    type="text"
                    id="username"
                    ref={userRef}
                    autoComplete="off"
                    onChange={(e) => setusername(e.target.value)}
                    label="Username"
                    value={username}
                    variant="standard"
                    InputProps={{
                      disableUnderline: true, // remove default underline
                    }}
                    required
                    className="w-4/5 text-center"
                    InputLabelProps={{ shrink: true }}
                    onKeyDown={submitFormKeyPress}
                    sx={{
                      "& .MuiInputBase-root": {
                        border: "1px solid #ccc",
                        borderRadius: "4px",
                        padding: "6px 12px",
                      },
                      "& input": {
                        padding: 0, // avoid double padding
                      },
                    }}
                  />
                  <TextField
                    type="password"
                    id="password"
                    onChange={(e) => setpassword(e.target.value)}
                    value={password}
                    label="Password"
                    variant="standard"
                    InputProps={{
                      disableUnderline: true, // remove default underline
                    }}
                    required
                    className="w-4/5 text-center"
                    InputLabelProps={{ shrink: true }}
                    onKeyDown={submitFormKeyPress}
                    sx={{
                      "& .MuiInputBase-root": {
                        border: "1px solid #ccc",
                        borderRadius: "4px",
                        padding: "6px 12px",
                      },
                      "& input": {
                        padding: 0, // avoid double padding
                      },
                      marginTop: "3px",
                    }}
                  />
                  <FormSubmitButton
                    isLoading={loading}
                    handleSubmit={async (e) => await handleSubmit(e)}
                    buttonText="Login"
                    buttonColor="#257df8"
                    buttonId="login-submit"
                    alignLeft={true}
                    sx={{
                      paddingLeft: "35px",
                      paddingRight: "35px",
                      fontWeight: "normal",
                      marginTop: "12px",
                    }}
                  />
                  {showPasswordReset ? (
                    <div className="pb-10">
                      <Button
                        onClick={() => setPassResetForgot(true)}
                        className="text-purple-600 hover:text-white hover:bg-purple-600"
                      >
                        Forgot password? Click here to reset
                      </Button>
                    </div>
                  ) : (
                    ""
                  )}
                </form>
              </div>
              <div style={{ display: "flex" }}>
                <img
                  src="/assets/his-login-image.png"
                  style={{ height: "518px" }}
                />
              </div>
            </div>
          </div>
        </>
      )}
      <div className="absolute bottom-[50px] flex justify-center gap-4 w-full">
        <a
          className="font-bold text-white normal-case hover:bg-transparent hover:underline"
          href={privacyLink}
          target="_blank"
          rel="noreferrer"
        >
          Privacy Policy
        </a>
        <a
          className="font-bold text-white normal-case hover:bg-transparent hover:underline"
          href={termsLink}
          target="_blank"
          rel="noreferrer"
        >
          Terms & Conditions
        </a>
      </div>
      <Dialog open={passResetForgot}>
        <div
          style={{
            padding: 20,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            width: "400px",
            position: "relative",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              width: "100%",
              fontSize: "20px",
            }}
          >
            <Button onClick={() => setPassResetForgot(false)}>
              <CloseIcon />
            </Button>
          </div>
          <h1
            style={{
              fontSize: 20,
              color: "orange",
              margin: "0 0 1rem 0",
              textAlign: "center",
              fontWeight: "bold",
            }}
          >
            Send Reset Password Email
          </h1>
          <TextField
            style={{
              width: "100%",
              margin: "1rem 0",
            }}
            className="w-full my-4 text-center"
            placeholder="Account Email" //
            type="text"
            autoComplete="off"
            label="Email"
            value={email}
            InputLabelProps={{ shrink: true }}
            onChange={(event) => setEmail(event.target.value)}
          />
        </div>
        <div style={{ margin: "0 0 2rem 0" }}>
          <ModalButton
            action={resetPasswordTrigger}
            baseColor={"#FFA500"}
            content={"Send"}
          />
        </div>
      </Dialog>
      <ResponseModal
        title="Success"
        description="Please check your email for a link to reset your password!"
        openBool={resetEmailDialog}
        setOpenBool={setResetEmailDialog}
      />
      <Modal
        maxWidth="xs"
        open={openErrorModal}
        onClose={() => setOpenErrorModal(false)}
      >
        <p
          className={`text-red-600 text-xl py-8 ${
            errorMessage ? "errmsg" : "offscreen"
          }`}
          aria-live="assertive"
        >
          {errorMessage}
        </p>
      </Modal>
      {!isError ? (
        ""
      ) : (
        <ResponseModal
          title="Password update failed"
          isError={true}
          openBool={isError}
          setOpenBool={setIsError}
          errorMessage={errorMessage}
        />
      )}
    </div>
  );
};

export default Login;
